<template>
  <div>
    <file-player-row :music="music" :is_hidden_name="hide_name" :is_file_converted="converted">
      <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope">
        <slot :name="slot" v-bind="scope"></slot>
      </template>
    </file-player-row>
  </div>
</template>

<script>
  import { getMediaPbxFilePath } from '@shared/helpers/url';
  import FilePlayerRow from '@shared/components/z-player-row';

  export default {
    components: {
      FilePlayerRow
    },

    props: {
      file: {
        type: Object,
        default: () => ({})
      },
      hide_name: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      music() {
        return {
          title: this.file.description,
          src: getMediaPbxFilePath(this.file.file)
        };
      },
      converted() {
        return !!this.file.sln_file;
      }
    }
  };
</script>
